<template>
  <font-awesome-icon
    :icon="$v6.solid[selectedSpinner]"
    :size="size"
    fixed-width
    spin
  />
</template>

<script>
  import sample from 'lodash/sample'

  const spinnerIcons = ['faCompass', 'faAtomSimple', 'faTireRugged', 'faGear', 'faLoader']

  export default {
    name: 'SampleSpinners',

    props: {
      size: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        selectedSpinner: sample(spinnerIcons)
      }
    }
  }
</script>
